import axios from 'axios';
import { API_BASE_URL, STORAGE_KEYS } from '../Utils/constants';

// Create an Axios instance for API service
const apiService = axios.create({
  baseURL: API_BASE_URL, // The base URL for the backend API
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor to add the Authorization header to every request
apiService.interceptors.request.use(
  (config) => {
    // Skip adding token for login endpoint
    if (config.url.includes('/api/authenticate')) {
      return config;
    }
    const token = localStorage.getItem(STORAGE_KEYS.TOKEN); // Get token from localStorage

    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`; // Attach token to request
    } else {
      console.warn('No token found in localStorage at the time of request.');
    }

    return config; // Proceed with the request
  },
  (error) => Promise.reject(error) // Handle request errors
);


// Interceptor to handle response errors globally
apiService.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', error.response?.data || error.message);
    if (error.response?.status === 401) {
      console.warn('Unauthorized error, checking logout logic.');
      // Ensure logout logic is not triggered unnecessarily
      if (!error.config.url.includes('/refresh-token')) {
        console.log('Clearing token and logging out.');
        localStorage.removeItem(STORAGE_KEYS.TOKEN);
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);


export default apiService;
